import ApartmentDataGridAction from './ApartmentDataGridAction';

export default ApartmentDataGridAction;
